import React from 'react';
import { ArrowDown, Phone } from 'lucide-react';
// Importado (no /images/...) para que el build le ponga un hash al nombre:
// así, al cambiar el logo, cambia la URL y ningún navegador sirve el viejo.
import logo from '../assets/images/sunshinelogo2.png';
import "../styles/Hero.css";

const Header = () => {

  // Imágenes de muestra para el carrusel
  const carouselImages = [
    "images/carousel4.jpg", // Imagen de exterior de casa
    "images/carousel1.jpg", // Imagen de ventanas limpias
    "images/carousel2.jpg", // Imagen de equipo trabajando
  ];

  const facts = [
    { value: "20 yrs", label: "In Los Angeles" },
    { value: "2,000+", label: "Clients this year" },
    { value: "24/7", label: "Availability" },
  ];

  return (
    <header className="hero">
      {/* Carrusel de Bootstrap a pantalla completa */}
      <div
        id="heroCarousel"
        className="hero__carousel carousel slide carousel-fade"
        data-bs-ride="carousel"
      >
        <div className="carousel-indicators">
          {carouselImages.map((_, index) => (
            <button
              key={`indicator-${index}`}
              type="button"
              data-bs-target="#heroCarousel"
              data-bs-slide-to={index}
              className={index === 0 ? "active" : ""}
              aria-current={index === 0 ? "true" : "false"}
              aria-label={`Slide ${index + 1}`}
            ></button>
          ))}
        </div>

        <div className="carousel-inner">
          {carouselImages.map((image, index) => (
            <div
              key={`slide-${index}`}
              className={`carousel-item ${index === 0 ? "active" : ""}`}
            >
              <img
                src={image}
                className="hero__slide"
                alt={`Sunshine Cleaning All - Servicio ${index + 1}`}
              />
            </div>
          ))}
        </div>

        <button
          className="carousel-control-prev"
          type="button"
          data-bs-target="#heroCarousel"
          data-bs-slide="prev"
        >
          <span className="carousel-control-prev-icon" aria-hidden="true"></span>
          <span className="visually-hidden">Previous slide</span>
        </button>
        <button
          className="carousel-control-next"
          type="button"
          data-bs-target="#heroCarousel"
          data-bs-slide="next"
        >
          <span className="carousel-control-next-icon" aria-hidden="true"></span>
          <span className="visually-hidden">Next slide</span>
        </button>
      </div>

      {/* Velo azul sobre la fotografía */}
      <div className="hero__scrim" aria-hidden="true"></div>

      <div className="hero__inner">
        <div className="container">
          <div className="hero__grid">
            <div className="hero__copy">
              <span className="eyebrow hero__eyebrow">
                Los Angeles
              </span>

              <h1 className="hero__title">
                Windows, floors and offices that <em>catch the light</em>.
              </h1>

              <p className="hero__lede">
                Residential and commercial cleaning across LA County, from a
                single storefront window to a full post-construction handover.
              </p>

              <div className="hero__actions">
                <button
                  type="button"
                  className="btn-sun btn-lg-brand"
                  data-bs-toggle="modal"
                  data-bs-target="#contactModal"
                >
                  Request a quote
                </button>
                <a
                  href="tel:+13109254824"
                  className="btn-ghost-light btn-lg-brand hero__phone"
                >
                  <Phone size={18} aria-hidden="true" />
                  (310) 925-4824
                </a>
              </div>

              <ul className="hero__facts">
                {facts.map((fact) => (
                  <li className="hero__fact" key={fact.label}>
                    <b>{fact.value}</b>
                    <span>{fact.label}</span>
                  </li>
                ))}
              </ul>
            </div>

            <div className="hero__badge">
              {/* Los rayos van dentro del contenedor de la insignia para que
                  siempre queden centrados y alineados con las puntas del sol */}
              <div className="hero__badgeWrap">
                <div className="hero__burst" aria-hidden="true"></div>
                <div className="hero__glow" aria-hidden="true"></div>
                <img
                  className="hero__logo"
                  src={logo}
                  alt="Sunshine Cleaning All"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <a className="hero__cue" href="#Services">
        Our services
        <ArrowDown size={16} aria-hidden="true" />
      </a>
    </header>
  );
}

export default Header;
